/** Monta linha do tempo de versões (original → revisões → atual). */
export function buildMessageEditVersions(message) {
  const history = Array.isArray(message?.editHistory)
    ? message.editHistory
    : Array.isArray(message?.metadata?.editHistory)
      ? message.metadata.editHistory
      : [];

  const versions = history.map((entry, idx) => ({
    content: String(entry?.content ?? ""),
    at: entry?.savedAt || entry?.editedAt || null,
    kind: idx === 0 ? "original" : "revision",
  }));

  if (message?.editedAt && !message?.deletedAt) {
    versions.push({
      content: String(message?.content ?? ""),
      at: message.editedAt,
      kind: "current",
    });
  }

  return versions.filter((v) => v.content.trim());
}

export function messageHasEditHistory(message) {
  return Boolean(message?.editedAt && !message?.deletedAt);
}
